import { fetchApi } from '@/config/axiosSetting.ts';
import {
  GetCulpritVehicleCorrectiveImageTabsResponseType,
  GetCulpritVehicleCorrectiveImageTabsType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritVehicleCorrectiveImageTabs/getCulpritVehicleCorrectiveImageTabs.type';

export const getCulpritVehicleCorrectiveImageTabsFunction = (
  params?: GetCulpritVehicleCorrectiveImageTabsType,
): Promise<GetCulpritVehicleCorrectiveImageTabsResponseType> =>
  fetchApi({
    url: `/property/reports/${params?.id}/accident_users/culprit/images/corrective/entry_tabs/`,
  });
